import { CSSProperties, FC } from "react";
import { Table, Typography } from "antd";
import clsx from "clsx";
import { Innovation, NewBusinessModel, Replacement } from "../../../../types/IntelligenceTypes";
import styles from "./EmergingTechnologies.module.less";

const { Column } = Table;

interface EmergingTechnologiesProps {
    replacements?: Replacement[];
    innovations?: Innovation[];
    newBusinessModels?: NewBusinessModel[];
    style?: CSSProperties;
}

export const EmergingTechnologies: FC<EmergingTechnologiesProps> = ({
    replacements,
    innovations,
    newBusinessModels,
    style,
}) => {
    return (
        <div style={style}>
            <div className={clsx(styles.title, "sectionTitle")}>
                Emerging technologies and market disruptors
            </div>
            <Table dataSource={replacements} pagination={false} size="small">
                <Column
                    title="Automation and AI replacements"
                    dataIndex="tool"
                    colSpan={2}
                    align="left"
                    width={334}
                />
                <Column
                    colSpan={0}
                    render={(_, row: Replacement) => (
                        <>
                            <div>
                                <Typography.Text strong>
                                    &bull; Replacement Potential:{" "}
                                </Typography.Text>
                                {row.potential}
                            </div>
                            <div>
                                <Typography.Text strong>
                                    &bull; Cost/Efficiency Benefits:{" "}
                                </Typography.Text>
                                {row.benefits}
                            </div>
                        </>
                    )}
                />
            </Table>
            <Table dataSource={innovations} pagination={false} size="small">
                <Column
                    title="Cross-Industry innovation"
                    dataIndex="competitor"
                    colSpan={2}
                    align="left"
                    width={334}
                />
                <Column
                    colSpan={0}
                    render={(_, row: Innovation) => (
                        <>
                            <div>
                                <Typography.Text strong>
                                    &bull; Offerings & Price Comparison:{" "}
                                </Typography.Text>
                                {row.comparison}
                            </div>
                            <div>
                                <Typography.Text strong>
                                    &bull; Risk of Disruption:{" "}
                                </Typography.Text>
                                {row.assessment}
                            </div>
                        </>
                    )}
                />
            </Table>
            <Table dataSource={newBusinessModels} pagination={false} size="small">
                <Column
                    title="New business models and subscription services"
                    dataIndex="model"
                    colSpan={2}
                    align="left"
                    width={334}
                />
                <Column
                    colSpan={0}
                    render={(_, row: NewBusinessModel) => (
                        <>
                            <div>
                                <Typography.Text strong>
                                    &bull; Comparison with Traditional Models:{" "}
                                </Typography.Text>
                                {row.comparison}
                            </div>
                            <div>
                                <Typography.Text strong>&bull; Cost Advantages: </Typography.Text>
                                {row.advantage}
                            </div>
                        </>
                    )}
                />
            </Table>
        </div>
    );
};
